import React from 'react';
import "./src/scss/global.scss";

window.process = {
  env: {
    NODE_ENV: "production",
  },
};
export const onRouteUpdate = loc => {
  var _j = document.createElement("script");
  _j.setAttribute("src", "https://public.jetlink.io/Sdk/Jetlink.js?j=" + new Date(Date()).getTime() / 1000);
  _j.onload = function () { Jetlink.Init("jetlink-web-chat-54ac0fe6-7160-494b", "ebdae03fa997447eb10cdea7ea036d6a"); };
  document.head.appendChild(_j);
}